<div class="relative z-50">
  <button (click)="toggleProfileMenu()"
          class="hover:text-gray-700 flex items-center focus:outline-none transition-transform active:scale-95">
    <div
         class="w-10 h-10 bg-brand-purple text-white rounded-full flex items-center justify-center text-sm font-bold shadow-md border-2 border-white hover:border-purple-100 transition-colors">
      {{ currentUser()?.firstName?.charAt(0) || '' }}{{ currentUser()?.lastName?.charAt(0) || '' }}
    </div>
  </button>

  @if (isProfileMenuOpen()) {
  <div class="absolute right-0 mt-3 w-72 bg-white rounded-xl shadow-xl border border-gray-100 py-4 origin-top-right animate-in fade-in slide-in-from-top-2">
    <div class="px-6 pb-4 border-b border-gray-50 flex flex-col items-center">
      <div
           class="w-16 h-16 bg-brand-purple text-white rounded-full flex items-center justify-center text-2xl font-bold mb-3 shadow-inner">
        {{ currentUser()?.firstName?.charAt(0) || '' }}{{ currentUser()?.lastName?.charAt(0) || '' }}
      </div>
      <h3 class="font-bold text-gray-900 text-lg">{{ currentUser()?.firstName }} {{ currentUser()?.lastName }}</h3>
    </div>

    <div class="px-6 py-4 space-y-4">
      <div class="flex items-center gap-3 text-gray-600 group">
        <div class="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-purple-50 transition-colors">
            <span class="material-icons text-gray-400 text-sm group-hover:text-brand-purple">email</span>
        </div>
        <span class="text-sm truncate font-medium">{{ currentUser()?.email || 'No email' }}</span>
      </div>
      <div class="flex items-center gap-3 text-gray-600 group">
        <div class="w-8 h-8 rounded-full bg-gray-50 flex items-center justify-center group-hover:bg-purple-50 transition-colors">
            <span class="material-icons text-gray-400 text-sm group-hover:text-brand-purple">phone</span>
        </div>
        <span class="text-sm font-medium">{{ currentUser()?.phoneNumber || 'No phone' }}</span>
      </div>
    </div>

    <div class="px-6 pt-2 border-t border-gray-50">
      <button (click)="logout()"
              class="w-full flex items-center justify-center gap-2 text-red-600 hover:bg-red-50 hover:text-red-700 py-2.5 rounded-lg transition-all text-sm font-bold mt-1">
        <span class="material-icons text-lg">logout</span> Sign Out
      </button>
    </div>
  </div>
  }
</div>